import { Component, OnInit,TemplateRef } from '@angular/core';
import { BsModalService } from 'ngx-bootstrap/modal';
import { Empty_LetterRequestCustomer_Funds_Interface, LetterRequestCustomer_Funds_Interface } from 'src/app/Interface/LetterRequestCustomer_Funds_Interface';
import { AlertifyService } from 'src/app/Service/Alertify.service';
import { FundsService } from 'src/app/Service/Funds/Funds.service';
import { NavService } from 'src/app/Service/Nav/Nav.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-FundsReview',
  templateUrl: './FundsReview.component.html',
  styleUrls: ['./FundsReview.component.scss']
})
export class FundsReviewComponent implements OnInit {
  Filter_Code: string = ""
  Filter_Username: string = ""
  OperationDsc: string = ""
  page: number = 0;
  InProccessing: boolean = false
  BaseUrl = environment.BaseUrl

  modalRef_Delete: any;

  constructor(
    private Funds_Service: FundsService,
    private Alertify_Service: AlertifyService,
    private Nav_Service: NavService,
    private modalService: BsModalService
  ) { }


  DataList_Funds: Array<LetterRequestCustomer_Funds_Interface> = []
  Data_Seleted_Delete: LetterRequestCustomer_Funds_Interface = Empty_LetterRequestCustomer_Funds_Interface()
  Data_Seleted_Delete_Status:number

  ngOnInit() {

    this.Nav_Service.CheckValidPage(1151).subscribe(
      data => {
        this.ReadData_Funds()
      }
      , error => {
        // AuthInterceptor owns authentication; feature errors must preserve credentials.
      }
    )


  }

  ReadData_Funds() {
    this.InProccessing = true
    this.Funds_Service.GetReview().subscribe(
      data => {
        this.DataList_Funds = data
        this.InProccessing = false
      }, error => {
        // AuthInterceptor owns authentication; feature errors must preserve credentials.

      }
    )
  }

  openModal(template: TemplateRef<any>,Record:LetterRequestCustomer_Funds_Interface,Status:number) {
    this.Data_Seleted_Delete = Record
    this.OperationDsc=""
    this.Data_Seleted_Delete_Status = Status
    this.modalRef_Delete = this.modalService.show(template);
  }

  Change_Filter() {
    this.page = 0
  }

  AnswerReview(){
    this.InProccessing=true
    this.modalRef_Delete.hide()
    this.Funds_Service.AnswerReview(this.Data_Seleted_Delete.id,
      this.Data_Seleted_Delete_Status,
      this.OperationDsc).subscribe(
      data=>{
        this.InProccessing = false

        this.ReadData_Funds()
      },error=>{
        // AuthInterceptor owns authentication; feature errors must preserve credentials.

      }
    )
  }

}
